import { IGBSRole } from '../../../Queries/AnalysutdelningQuery/AnalysutdelningQuery';

export const getGbsRoles = (codes: string, gbsRoles: IGBSRole[]): IGBSRole[] =>
  codes
    .split(',')
    .map(
      code =>
        gbsRoles.find(gbsRole => gbsRole.code === code.trim()) ?? {
          __typename: 'TEDAvenyGBSRole' as 'TEDAvenyGBSRole',
          id: 'None',
          code: '',
          name: '',
        }
    )
    .filter(role => role.id !== 'None');
